export type {
  Address,
  BigIntString,
  SeatData,
  V2Grid,
  V2GridSeat,
  V2GridPageData,
  GridApiResponse,
  LobbyGridSummary,
  GridRef,
  TakeoverSDKConfig,
} from './types';

export { V2_CONSTANTS } from './types';

export type { NetworkPreset } from './networks';
export { base, sepolia, NETWORKS, getNetwork } from './networks';

export function createTakeoverSDK(
  config: Omit<import('./types').TakeoverSDKConfig, 'chatBackendUrl'> & {
    chatBackendUrl?: string;
  },
): import('./types').TakeoverSDKConfig {
  return {
    ...config,
    chatBackendUrl: config.chatBackendUrl ?? config.apiBaseUrl,
  };
}
